<template>
  <div class="f-main bgImg container quiz-page">
    <div class="box" :style="wrapperStyle" v-loading="loading">
      <div class="title">
        <div class="title-main">
          <div class="title-left">
            <div class="title-icon" aria-hidden="true">
              <i class="el-icon-document" />
            </div>
            <div class="title-text">
              <div class="title-tags">
                <span class="tag">{{ $t('studentQuiz.Question') }} {{ currentIndex + 1 }}</span>
                <span class="tag tag-accent">AI Test</span>
              </div>
              <div class="textName">{{ questionsData?.testName || '' }}</div>
              <div class="question-sub">
                {{ $t("studentQuiz.Question") }} {{ currentIndex + 1 }} {{ $t("studentQuiz.of") }} {{ questionsData?.questions?.length || testQuestionsNumber }}
              </div>
            </div>
          </div>
          <div class="title-right">
            <div class="stat-box">
              <span class="stat-num">{{ percentage }}</span>
              <span class="stat-label">{{ $t("studentQuiz.complete") }}</span>
            </div>
            <div class="stat-box">
              <span class="stat-num">{{ currentIndex + 1 }}/{{ questionsData?.questions?.length || testQuestionsNumber }}</span>
              <span class="stat-label">Progress</span>
            </div>
            <div class="time" v-if="type === 'quiz'">
              <i class="el-icon-timer" />
              <span>{{ totalTime }}</span>
            </div>
            <div v-else class="home">
              <el-button type="primary" @click="toHome">{{ $t("studentHomepage.home") }}</el-button>
            </div>
          </div>
        </div>

        <div class="title-progress">
          <div class="progress-top">
            <span>Progress</span>
            <span>{{ percentage }} complete</span>
          </div>
          <el-progress
            :percentage="Number(percentage.replace('%', ''))"
            :show-text="false"
            :stroke-width="8"
            color="#7c4dff"
          ></el-progress>
        </div>

        <i class="el-icon-close close" @click="close"></i>
      </div>

      <div class="question-index" v-if="questionsData?.questions?.length > 0">
        <button
          v-for="(q, index) in questionsData.questions"
          :key="q.questionId || index"
          type="button"
          class="q-dot"
          :class="{
            active: index === currentIndex,
            done: questionInfo[index] && questionInfo[index].studentAnswer,
            'q-dot-wrong-historical': type === 'historical' && isHistoricalWrong(index)
          }"
          @click="currentIndex = index"
        >
          {{ index + 1 }}
        </button>
      </div>

      <!-- 修复：添加条件渲染，确保有数据才渲染内容 -->
      <div class="content" v-if="questionsData?.questions?.length > 0">
        <div class="stem">
          <div class="stem-title">
            <span class="stem-badge">Question {{ currentIndex + 1 }}</span>
            <span class="stem-name">
              {{
                $i18n.locale === "en"
                  ? questionsData.questions[currentIndex].questionTitle
                  : questionsData.questions[currentIndex].questionTitleFr
              }}
            </span>
          </div>
          <div
            class="stem-content"
            v-html="renderMathText(
              $i18n.locale === 'en'
                ? questionsData.questions[currentIndex].questionContent
                : questionsData.questions[currentIndex].questionContentFr
            )"
          />
        </div>

        <div class="option">
          <el-radio-group
            v-model="questionInfo[currentIndex].studentAnswer"
            @change="handleAnswerChange"
          >
            <el-radio-button
              v-for="(option, optionIndex) in currentQuestionOptions"
              :disabled="type !== 'quiz'"
              :key="`${option.value}-${optionIndex}`"
              :label="option.value"
              class="option-item"
              :class="{
                'option-item-student-wrong': isHistoricalStudentWrongOption(option.value, currentIndex),
                'option-item-correct-historical': isHistoricalCorrectOption(option.value, currentIndex)
              }"
            >
              <span class="option-badge">{{ option.label || String.fromCharCode(65 + optionIndex) }}</span>
              <span class="option-text" v-html="renderMathText(option.text)" />
            </el-radio-button>
          </el-radio-group>
          <div
            v-if="type !== 'quiz'"
            class="answerExplanation"
            :class="{ 'answerExplanation-wrong-historical': type === 'historical' && isHistoricalWrong(currentIndex) }"
            v-html="renderMathText(
              $i18n.locale === 'en'
                ? questionsData.questions[currentIndex].answerExplanation
                : questionsData.questions[currentIndex].answerExplanationFr
            )"
          />
        </div>

        <div class="buttons">
          <el-button
            icon="el-icon-arrow-left"
            :disabled="currentIndex === 0"
            plain
            @click="currentIndex--"
          >
            {{ $t("studentQuiz.Previous") }}
          </el-button>
          <div class="current-no">{{ currentIndex + 1 }}/{{ questionsData.questions.length }}</div>
          <el-button
            :disabled="currentIndex === (questionsData.questions.length - 1)"
            type="primary"
            @click="currentIndex++"
          >
            {{ $t("studentQuiz.Next") }}
            <i class="el-icon-arrow-right" />
          </el-button>
        </div>

        <div class="submit" v-if="percentage === '100%' && type === 'quiz'">
          <el-button type="primary" @click="submit">
            {{ $t("studentQuiz.submit") }}
          </el-button>
        </div>
      </div>

      <div v-else-if="!loading" class="empty-tip">
        {{ $t("studentQuiz.noQuestionData") }}
      </div>
    </div>
    <div class="footer">{{ $t("common.footer") }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { generateRandom, getQuestionsTest } from '@/api/tutor/student'
import 'katex/dist/katex.min.css'
import katex from 'katex'

export default {
  name: 'index',
  props: {
    scale: {
      type: Number,
      required: 1
    }
  },
  data () {
    return {
      // 修复1：初始化包含空数组的结构，避免访问 questions 时为 undefined
      questionsData: { questions: [] },
      testQuestionsNumber: 10,
      currentIndex: 0,
      questionInfo: [],
      totalTime: '00:00:00',
      timer: null,
      seconds: 0,
      startTime: Date.now(),
      type: '',
      loading: false
    }
  },
  computed: {
    ...mapState('user', {
      userInfo: (state) => state.userInfo
    }),
    wrapperStyle () {
      return {
        transform: `scale(${this.scale})`
      }
    },
    currentQuestionOptions () {
      const question = this.questionsData?.questions?.[this.currentIndex]
      if (!question) {
        return []
      }
      return this.parseQuestionOptions(question.options)
    },
    percentage () {
      if (this.questionInfo.length === 0) {
        return '0%'
      }
      const answeredCount = this.questionInfo.filter(
        (item) => item.studentAnswer !== null
      ).length
      const percentage = (answeredCount / this.questionInfo.length) * 100
      return percentage.toFixed(0) + '%'
    }
  },
  mounted () {
    this.type = this.$route.query.type
    if (this.type === 'quiz') {
      this.getQuestionsData()
      this.startTimer()
      this.startTime = Date.now()
    } else {
      this.getQuestionsTest()
    }
  },
  beforeDestroy () {
    this.stopTimer()
    this.recordCurrentQuestionTime(this.currentIndex)
  },
  watch: {
    currentIndex (newIndex, oldIndex) {
      // 当题目索引改变时，计算并保存**上一题**（oldIndex）所花费的时间
      if (oldIndex !== -1) { // 防止初始 undefined 情况
        this.recordCurrentQuestionTime(oldIndex)
      }
      // 更新当前题目的开始时间
      this.startTime = Date.now()
    }
  },
  methods: {
    /**
     * 解析题目选项，兼容数组/对象/字符串，并对非法反斜杠做容错。
     * @param {unknown} rawOptions 接口返回的原始 options 字段
     * @returns {Array<{label: string, value: string, text: string}>}
     */
    parseQuestionOptions (rawOptions) {
      if (Array.isArray(rawOptions)) {
        return rawOptions.map((item, index) => this.normalizeOptionItem(item, index))
      }

      if (rawOptions && typeof rawOptions === 'object') {
        return Object.keys(rawOptions).map((key, index) => {
          const text = String(rawOptions[key] ?? '').trim()
          return this.normalizeOptionItem(`${key}. ${text}`, index)
        })
      }

      if (typeof rawOptions !== 'string') {
        return []
      }

      const optionText = rawOptions.trim()
      let parsed
      try {
        parsed = JSON.parse(optionText)
      } catch (error) {
        const fixedOptions = this.escapeInvalidBackslashes(optionText)
        try {
          parsed = JSON.parse(fixedOptions)
        } catch (parseError) {
          const extracted = this.extractQuotedOptions(optionText)
          if (extracted.length > 0) {
            return extracted.map((item, index) => this.normalizeOptionItem(item, index))
          }
          const lines = optionText
            .split(/\r?\n/)
            .map((line) => line.trim())
            .filter(Boolean)
          return lines.map((line, index) => this.normalizeOptionItem(line, index))
        }
      }

      if (Array.isArray(parsed)) {
        return parsed.map((item, index) => this.normalizeOptionItem(item, index))
      }

      if (parsed && typeof parsed === 'object') {
        return Object.keys(parsed).map((key, index) => {
          const text = String(parsed[key] ?? '').trim()
          return this.normalizeOptionItem(`${key}. ${text}`, index)
        })
      }

      return []
    },
    /**
     * 将 JSON 文本中的非法转义反斜杠转为合法形式，避免 JSON.parse 报错。
     * @param {string} text 原始字符串
     * @returns {string}
     */
    escapeInvalidBackslashes (text) {
      const validEscapes = new Set(['"', '\\', '/', 'b', 'f', 'n', 'r', 't', 'u'])
      let output = ''
      for (let i = 0; i < text.length; i++) {
        const char = text[i]
        if (char !== '\\') {
          output += char
          continue
        }
        const nextChar = text[i + 1]
        if (!nextChar) {
          output += '\\\\'
          continue
        }
        if (validEscapes.has(nextChar)) {
          output += '\\'
        } else {
          output += '\\\\'
        }
      }
      return output
    },
    /**
     * 从 JSON-like 字符串中提取双引号包裹的选项文本。
     * @param {string} text 原始 options 字符串
     * @returns {string[]}
     */
    extractQuotedOptions (text) {
      const pattern = /"((?:\\.|[^"\\])*)"/g
      const result = []
      let matched = pattern.exec(text)
      while (matched) {
        result.push(this.decodeEscapedText(matched[1]))
        matched = pattern.exec(text)
      }
      return result
    },
    /**
     * 还原常见转义字符，保证选项展示正常。
     * @param {string} text 选项文本
     * @returns {string}
     */
    decodeEscapedText (text) {
      return String(text)
        .replace(/\\n/g, '\n')
        .replace(/\\r/g, '\r')
        .replace(/\\t/g, '\t')
        .replace(/\\"/g, '"')
        .replace(/\\\//g, '/')
        .replace(/\\\\/g, '\\')
    },
    /**
     * 转义 HTML 字符，避免文本被当成标签执行。
     * @param {string} text 原始文本
     * @returns {string}
     */
    escapeHtml (text) {
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    },
    /**
     * 渲染文本中的 LaTeX 公式，支持 \\(...\\)、\\[...\\] 与 $...$。
     * @param {unknown} content 原始文本
     * @returns {string}
     */
    renderMathText (content) {
      if (content === null || content === undefined) {
        return ''
      }
      const normalizedContent = this.normalizeFormulaDelimiters(String(content))
      let text = this.escapeHtml(normalizedContent)
      const renderFormula = (formula, displayMode = false) => {
        try {
          const normalizedFormula = this.normalizeLatexFormula(formula)
          return katex.renderToString(normalizedFormula, {
            displayMode,
            throwOnError: false,
            strict: false
          })
        } catch (error) {
          return this.escapeHtml(formula)
        }
      }
      text = text.replace(/\\\[(.*?)\\\]/gs, (_, formula) => renderFormula(formula, true))
      text = text.replace(/\\\((.*?)\\\)/gs, (_, formula) => renderFormula(formula, false))
      text = text.replace(/\$(.*?)\$/gs, (_, formula) => renderFormula(formula, false))
      return text.replace(/\n/g, '<br>')
    },
    /**
     * 自动补全不成对的 LaTeX 分隔符，避免公式无法被识别。
     * @param {string} text 原始文本
     * @returns {string}
     */
    normalizeFormulaDelimiters (text) {
      let result = String(text)
      const inlineOpen = (result.match(/\\\(/g) || []).length
      const inlineClose = (result.match(/\\\)/g) || []).length
      if (inlineOpen > inlineClose) {
        result += '\\)'.repeat(inlineOpen - inlineClose)
      }
      const blockOpen = (result.match(/\\\[/g) || []).length
      const blockClose = (result.match(/\\\]/g) || []).length
      if (blockOpen > blockClose) {
        result += '\\]'.repeat(blockOpen - blockClose)
      }
      return result
    },
    /**
     * 将错误反序列化后的控制字符还原为 LaTeX 命令前缀。
     * 例如：\f -> \\f、\t -> \\t，避免 KaTeX 报错变红。
     * @param {string} formula 原始公式内容
     * @returns {string}
     */
    normalizeLatexFormula (formula) {
      const controlCharMap = {
        '\b': '\\b',
        '\f': '\\f',
        '\t': '\\t',
        '\n': '\\n',
        '\r': '\\r'
      }
      return String(formula)
        .replace(/[\b\f\t\n\r]/g, (char) => controlCharMap[char] || char)
        .trim()
    },
    /**
     * 将接口选项项标准化为统一展示结构。
     * @param {unknown} item 单个选项数据
     * @param {number} index 选项索引
     * @returns {{label: string, value: string, text: string}}
     */
    normalizeOptionItem (item, index) {
      const rawText = String(item ?? '').trim()
      const letter = String.fromCharCode(65 + index)
      const match = rawText.match(/^([A-Za-z])[\.\)]\s*(.*)$/)
      if (match) {
        return {
          label: match[1].toUpperCase(),
          value: match[1].toUpperCase(),
          text: match[2].trim()
        }
      }

      return {
        label: letter,
        value: letter,
        text: rawText
      }
    },
    /**
     * 选择答案后自动跳转到下一题（仅练习模式）。
     * @param {string} value 当前选中的选项值
     * @returns {void}
     */
    handleAnswerChange (value) {
      if (this.type !== 'quiz') {
        return
      }
      if (!value) {
        return
      }
      const total = this.questionsData?.questions?.length || 0
      if (this.currentIndex < total - 1) {
        this.currentIndex++
      }
    },
    startTimer () {
      this.timer = setInterval(() => {
        this.seconds++
        this.updateTotalTime()
      }, 1000)
    },
    stopTimer () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    updateTotalTime () {
      const hours = Math.floor(this.seconds / 3600)
      const minutes = Math.floor((this.seconds % 3600) / 60)
      const seconds = this.seconds % 60

      this.totalTime = `${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(seconds)}`
    },
    padZero (num) {
      return num.toString().padStart(2, '0')
    },
    recordCurrentQuestionTime (questionIndex) {
      // 修复2：添加边界判断，避免访问 undefined 的数组项
      if (!this.questionInfo || questionIndex >= this.questionInfo.length) {
        return
      }
      // 计算从 startTime 到现在的时间差（毫秒）
      const timeSpent = Date.now() - this.startTime
      // 将时间差（转换为秒）更新到 questionInfo 数组中指定的索引位置
      if (this.questionInfo[questionIndex] !== undefined) {
        this.questionInfo[questionIndex].timeSpent = Math.round(timeSpent / 1000)
      }
      // 注意：这里不重置 startTime
    },
    getQuestionsData () {
      const params = {
        studentId: this.$route.query.studentId,
        knowledgePointId: this.$route.query.knowledgePointId,
        difficultyLevel: this.$route.query.difficultyLevel,
        questionCount: this.testQuestionsNumber
      }
      this.loading = true
      generateRandom(params).then((res) => {
        this.loading = false
        if (res.code !== 200) {
          return false
        }
        const list = res.data?.questions || []
        this.questionInfo = [] // 修复3：清空原有数据，避免长度不一致
        list.forEach((item) => {
          const info = {
            questionId: item.questionId,
            studentAnswer: null,
            timeSpent: 0
          }
          this.questionInfo.push(info)
        })
        this.questionsData = res.data
      })
    },
    submit () {
      this.recordCurrentQuestionTime(this.currentIndex)
      const info = {
        testRecordId: this.questionsData.id,
        studentId: this.$route.query.studentId,
        answers: this.questionInfo
      }
      this.$store.dispatch('student/storeTestAnswers', info)
      this.$router.push({
        path: '/quizResults',
        query: {
          testRecordId: this.questionsData.id,
          gradeId: this.$route.query.gradeId,
          studentId: this.$route.query.studentId,
          categoryId: this.$route.query.categoryIds,
          knowledgePointId: this.$route.query.knowledgePointId,
          difficultyLevel: this.$route.query.difficultyLevel
        }
      })
    },
    getQuestionsTest () {
      this.loading = true // 修复4：添加loading状态
      getQuestionsTest({ testRecordId: this.$route.query.testRecordId }).then((res) => {
        this.loading = false
        if (res.code !== 200) {
          return false
        }
        const list = res.data?.questions || []
        this.questionInfo = [] // 修复3：清空原有数据
        list.forEach((item) => {
          const info = {
            questionId: item.questionId,
            studentAnswer: this.getHistoricalStudentAnswer(item),
            timeSpent: 0
          }
          this.questionInfo.push(info)
        })
        this.questionsData = res.data
      })
    },
    /**
     * 历史模式下解析学生作答选项，优先使用接口返回的 studentAnswer。
     * @param {Record<string, any>} item 题目数据
     * @returns {string|null}
     */
    getHistoricalStudentAnswer (item) {
      const answerCandidates = [
        item?.studentAnswer,
        item?.studentOption,
        item?.userAnswer,
        item?.myAnswer
      ]
      for (const candidate of answerCandidates) {
        if (candidate !== null && candidate !== undefined && String(candidate).trim() !== '') {
          return String(candidate).trim().toUpperCase()
        }
      }
      if (item?.correctAnswer !== null && item?.correctAnswer !== undefined) {
        return String(item.correctAnswer).trim().toUpperCase()
      }
      return null
    },
    toHome () {
      this.$router.go(-1)
    },
    close () {
      this.$confirm(this.$t('pointLearn.$confirm'), '', {
        confirmButtonText: this.$t('pointLearn.confirm'),
        cancelButtonText: this.$t('pointLearn.Cancel'),
        type: 'warning'
      }).then(() => {
        this.$router.go(-1)
      })
    },
    /**
     * 历史回顾：接口判定该题答错时，题号圆点与讲解区标红
     * @param {number} index 题目下标
     * @returns {boolean}
     */
    isHistoricalWrong (index) {
      if (this.type !== 'historical') return false
      const q = this.questionsData?.questions?.[index]
      if (!q || q.isCorrect === undefined || q.isCorrect === null) return false
      const v = q.isCorrect
      if (v === false || v === 0) return true
      if (typeof v === 'string') {
        const s = v.trim().toLowerCase()
        return s === 'false' || s === '0' || s === 'n' || s === 'no'
      }
      return false
    },
    /**
     * 判断历史错题中某个选项是否为学生选择项。
     * @param {string} optionValue 选项值
     * @param {number} questionIndex 题目下标
     * @returns {boolean}
     */
    isHistoricalStudentWrongOption (optionValue, questionIndex) {
      if (this.type !== 'historical') return false
      if (!this.isHistoricalWrong(questionIndex)) return false
      const selected = this.questionInfo?.[questionIndex]?.studentAnswer
      if (selected === null || selected === undefined) return false
      const selectedValue = String(selected).trim().toUpperCase()
      const option = String(optionValue).trim().toUpperCase()
      if (selectedValue !== option) return false
      const correct = this.getHistoricalCorrectAnswer(questionIndex)
      if (!correct) return true
      return selectedValue !== correct
    },
    /**
     * 获取历史题目的正确答案选项值。
     * @param {number} questionIndex 题目下标
     * @returns {string}
     */
    getHistoricalCorrectAnswer (questionIndex) {
      const q = this.questionsData?.questions?.[questionIndex]
      if (!q) return ''
      const raw = q.correctAnswer ?? q.correctAnswerFr
      if (raw === null || raw === undefined) return ''
      return String(raw).trim().toUpperCase()
    },
    /**
     * 判断历史题某个选项是否为正确答案。
     * @param {string} optionValue 选项值
     * @param {number} questionIndex 题目下标
     * @returns {boolean}
     */
    isHistoricalCorrectOption (optionValue, questionIndex) {
      if (this.type !== 'historical') return false
      const correct = this.getHistoricalCorrectAnswer(questionIndex)
      if (!correct) return false
      return String(optionValue).trim().toUpperCase() === correct
    }
  }
}
</script>

<style scoped>
.quiz-page {
  --qz-purple: #7c4dff;
  --qz-purple-deep: #5b21b6;
  --qz-orange: #ff8a00;
}

.quiz-page.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100% - 90px);
  padding: 12px 16px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #f3e8ff 0%, #ede7f6 45%, #e8e0f5 100%);
}

.page-tagline {
  width: 100%;
  max-width: 1480px;
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.12em;
  color: #fff;
  background: var(--qz-purple-deep);
  padding: 8px 16px;
  border-radius: 999px;
  margin-bottom: 12px;
}

.quiz-page .box {
  width: 100%;
  max-width: 1200px;
  min-height: 780px;
  display: flex;
  flex-direction: column;
  padding: 20px 24px 24px;
}

.title {
  background: linear-gradient(115deg, #7c4dff 0%, #6366f1 45%, #2563eb 100%);
  border-radius: 18px;
  padding: 20px 20px 14px;
  position: relative;
  box-shadow: 0 12px 40px rgba(91, 33, 182, 0.2);
}

.title-main {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  align-items: center;
}

.title-left {
  display: flex;
  gap: 14px;
  flex: 1;
  min-width: 0;
  align-items: center;
}

.title-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
  flex-shrink: 0;
}

.title-tags {
  display: flex;
  gap: 8px;
  margin-bottom: 6px;
}

.tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
}

.tag-accent {
  background: rgba(255, 138, 0, 0.95);
}

.textName {
  font-weight: 900;
  font-size: 32px;
  line-height: 1.2;
  color: #fff;
}

.question-sub {
  margin-top: 4px;
  font-weight: 600;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.92);
}

.title-right {
  display: flex;
  gap: 10px;
  align-items: center;
}

.stat-box {
  min-width: 86px;
  height: 56px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(2px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
}

.stat-num {
  color: #fff;
  font-size: 20px;
  font-weight: 900;
  line-height: 1;
}

.stat-label {
  margin-top: 4px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 11px;
  font-weight: 600;
}

.time {
  min-width: 110px;
  height: 44px;
  border-radius: 12px;
  background: rgba(35, 23, 103, 0.45);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 900;
}

.home :deep(.el-button) {
  height: 44px;
  border-radius: 999px;
  padding: 0 20px;
  font-weight: 800;
  background: var(--qz-orange);
  border-color: transparent;
}

.title-progress {
  margin-top: 12px;
}

.progress-top {
  display: flex;
  justify-content: space-between;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 6px;
}

.title-progress :deep(.el-progress-bar__outer) {
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.24);
}

.title-progress :deep(.el-progress-bar__inner) {
  border-radius: 999px;
}

.close {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5b21b6;
  background: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  cursor: pointer;
}

.question-index {
  margin: 16px 0 8px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}

.q-dot {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
}

.q-dot.active {
  background: linear-gradient(90deg, #7c4dff 0%, #5b21b6 100%);
  color: #fff;
  border-color: transparent;
}

.q-dot.done:not(.active) {
  background: #ede9fe;
  color: #5b21b6;
  border-color: #5b21b6;
}

/* 历史回顾：答错题号圆点、讲解框 — 红色强调 */
.q-dot.q-dot-wrong-historical:not(.active) {
  background: #fef2f2;
  border: 2px solid #dc2626;
  color: #b91c1c;
}

.q-dot.q-dot-wrong-historical.done:not(.active) {
  background: #fee2e2;
  border-color: #dc2626;
  color: #991b1b;
}

.q-dot.q-dot-wrong-historical.active {
  background: linear-gradient(90deg, #ef4444 0%, #dc2626 100%);
  color: #fff;
  border-color: transparent;
}

.answerExplanation-wrong-historical {
  color: #991b1b !important;
  background: #fef2f2 !important;
  border: 2px solid #ef4444 !important;
}

.content {
  margin-top: 8px;
  padding: 0;
}

.stem {
  border-radius: 16px;
  background: linear-gradient(90deg, #f8f5ff 0%, #eef2ff 100%);
  border: 1px solid #e5e7eb;
  padding: 16px 20px;
}

.stem-title {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.stem-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(90deg, #7c4dff 0%, #5b21b6 100%);
}

.stem-name {
  font-size: 15px;
  font-weight: 700;
  color: #475569;
}

.stem-content {
  margin-top: 12px;
  font-size: 30px;
  font-weight: 500;
  color: #111827;
  line-height: 1.45;
}

.option {
  margin-top: 14px;
}

.option :deep(.el-radio-group) {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.option :deep(.el-radio-button) {
  width: 100%;
}

.option :deep(.el-radio-button__inner) {
  width: 100%;
  height: 64px;
  border: 1px solid #e5e7eb !important;
  border-radius: 12px !important;
  background: #fff;
  box-shadow: none !important;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-start;
  padding: 0 14px !important;
  font-size: 15px;
  font-weight: 700;
}

.option :deep(.el-radio-button__orig-radio:checked + .el-radio-button__inner) {
  background: #f3f0ff;
  border-color: #7c4dff !important;
  color: #111827;
  box-shadow: 0 0 0 2px rgba(124, 77, 255, 0.2) inset !important;
}

.option :deep(.el-radio-button.option-item-student-wrong .el-radio-button__orig-radio:checked + .el-radio-button__inner) {
  background: #fef2f2;
  border-color: #ef4444 !important;
  color: #991b1b;
  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2) inset !important;
}

.option :deep(.el-radio-button.option-item-correct-historical .el-radio-button__inner) {
  background: #f0fdf4;
  border-color: #22c55e !important;
  color: #166534;
  box-shadow: 0 0 0 1px rgba(34, 197, 94, 0.25) inset !important;
}

.option-badge {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(145deg, #7c4dff 0%, #5b21b6 100%);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 900;
  flex-shrink: 0;
}

.option-text {
  white-space: normal;
  text-align: left;
  font-size: 20px;
}

.answerExplanation {
  margin-top: 12px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #fff;
  padding: 14px;
  font-size: 14px;
  line-height: 1.5;
  color: #334155;
  max-height: 120px;
  overflow: auto;
}

.buttons {
  margin-top: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.buttons .current-no {
  font-size: 18px;
  font-weight: 900;
  color: #64748b;
}

.buttons :deep(.el-button) {
  min-width: 180px;
  height: 44px;
  border-radius: 999px;
  padding: 0 18px;
  font-weight: 800;
}

.buttons :deep(.el-button--default.is-plain) {
  background: #f8fafc;
  color: #94a3b8;
  border-color: #e2e8f0;
}

.buttons :deep(.el-button--primary) {
  background: linear-gradient(90deg, #7c4dff 0%, #5b21b6 100%);
  border-color: transparent;
}

.submit {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

.submit :deep(.el-button) {
  min-width: 220px;
  height: 44px;
  border-radius: 999px;
  font-weight: 800;
}

.empty-tip {
  text-align: center;
  font-size: 16px;
  color: #64748b;
  padding: 50px 0;
}

.quiz-page .footer {
  margin-top: 16px;
  font-weight: 400;
  font-size: 11px;
  color: #94a3b8;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
</style>
